import type { RootState } from "@/src/common/redux/store";

export const getColorScheme = (state: RootState) => state.general.colorScheme;
export const getColorSchemePreference = (state: RootState) => state.general.colorSchemePreference ?? "system";
export const getSelectedSchoolId = (state: RootState) => state.general.selectedSchoolId;
export const getThemePreview = (state: RootState) => state.general.themePreview;
